<kendo-dialog
	title="Documents"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	[width]="350">
	<div class="kpa-offline-dialog-window">
		<div class="flex-table">
			<div class="flex-header">
				<div class="flex-column">Name</div>
			</div>
			<div
				class="flex-body"
				*ngFor="let attachment of offlineAttachments">
				<div class="flex-column">
					<button
						class="offline-doc-download wrap-btn"
						kendoButton
						[title]="attachment.title"
						(click)="downloadFileByFileId(attachment)">
						{{ attachment.title }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<kendo-dialog-actions [layout]="'end'">
		<button
			style="width: 30%"
			kendoButton
			kpaKendoButton="primary"
			(click)="close('dialog')">
			Okay
		</button>
	</kendo-dialog-actions>
</kendo-dialog>
